import { createElement, memo } from "react";
import { SECTION_COMPONENTS } from "./sectionRegistry";

export interface ComponentProps<T> {
  section?: T,
  page?: unknown,
  className?: string,
  /** position in the dynamic zone — lets a section know it is above the fold
   *  (MapSection uses it to priority-load the map image when it is the LCP) */
  index?: number
}

const DynamicZoneComponent = memo(function DynamicZoneComponent(props: { componentProps: unknown,
  index: number,
  parentProps?: unknown, }) {

  const uid = (props.componentProps as { __component?: string })?.__component;
  const component = uid ? SECTION_COMPONENTS[uid] : undefined;

  if (!component) {
    if (process.env.NODE_ENV !== "production") {
      console.warn(`DynamicZoneComponent: no renderer registered for "${uid}"`);
    }
    return null;
  }

  return createElement(component, {
    section: props.componentProps,
    page: props.parentProps,
    index: props.index,
  });
});

export default DynamicZoneComponent;
